import {Action} from '@ngrx/store';
import {DressCodePicture} from '../../../models/dress-code-picture';

export class GetDressCodePicturesSuccessAction implements Action {
  public static readonly type = 'GetDressCodePicturesSuccessAction';

  constructor(public dressCodePictures: DressCodePicture[]) {
  }

  public type = GetDressCodePicturesSuccessAction.type;
}
